import { styled } from '@mui/material/styles';
import { Paper, TextField, Box, Button, Typography } from '@mui/material';

export const BasePaper = styled(Paper)(({ theme }) => ({
  background: 'rgba(26, 31, 46, 0.6)',
  borderRadius: '16px',
  padding: theme.spacing(3),
  position: 'relative',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  backdropFilter: 'blur(12px)',
  transition: 'all 0.2s ease-in-out',
  borderTop: '2px solid transparent',
  borderImage: 'linear-gradient(90deg, #0EA5E9 0%, #22D3EE 100%) 1',
  '&:hover': {
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)',
  }
}));

export const GlassInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    background: 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(8px)',
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    color: 'rgba(255, 255, 255, 0.9) !important',
    '& input, & .MuiSelect-select, & textarea': {
      color: 'rgba(255, 255, 255, 0.9) !important',
      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.5)',
        opacity: 1,
      }
    },
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.12)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&.Mui-focused': {
      boxShadow: '0 0 0 2px rgba(14, 165, 233, 0.2)',
      '& fieldset': {
        borderColor: '#0EA5E9',
      }
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255, 255, 255, 0.7)',
    }
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.9)',
    '&.Mui-focused': {
      color: '#0EA5E9',
    }
  }
}));

export const InputLabel = styled(Typography)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.9)',
  fontSize: '0.875rem',
  marginBottom: theme.spacing(1),
  fontWeight: 500,
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(135deg, #0EA5E9, #10B981)',
  borderRadius: '12px',
  padding: '10px 24px',
  transition: 'all 0.3s ease',
  textTransform: 'none',
  color: 'rgba(255, 255, 255, 0.9)',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(14, 165, 233, 0.4)',
  },
  '&:active': {
    transform: 'translateY(1px)',
  }
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  color: '#22D3EE',
  fontSize: '0.875rem',
  marginTop: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& svg': {
    fontSize: '1rem',
    color: '#0EA5E9',
  }
}));

export const ActionToggle = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: '8px 16px',
  borderRadius: '8px',
  cursor: 'pointer',
  color: 'rgba(255, 255, 255, 0.7)',
  transition: 'all 0.2s ease',
  border: '1px solid rgba(255, 255, 255, 0.12)',
  background: 'rgba(255, 255, 255, 0.03)',
  '&:hover': {
    color: '#0EA5E9',
    background: 'rgba(14, 165, 233, 0.1)',
    borderColor: 'rgba(14, 165, 233, 0.3)',
    transform: 'translateY(-1px)',
  },
  '&.active': {
    color: '#0EA5E9',
    borderColor: '#0EA5E9',
    background: 'rgba(14, 165, 233, 0.1)',
  }
})); 